module.exports = __webpack_public_path__ + "static/media/Rotessa-Clearing-Account-Info-2.344352d2.jpg";